import { useEffect } from "react";
import { getRootIdByIvaType } from "../indexConfig";
import { AlmeIvaTypeProp } from "../models/AlmeIvaTypeMapping";
import defaultLogger from '../Logger';

export function useInlineIvaStyles(
    isOpen?: boolean,
    ivaType?: AlmeIvaTypeProp,
): void {
    useEffect(() => {
        const ivaRootId = getRootIdByIvaType(ivaType);
        const ivaRootElement = document.getElementById(ivaRootId);
        if (!ivaRootElement) {
            defaultLogger.warn('Failed to get IVA root element: ');
            return;
        }

        if (!ivaType || ivaType !== 'inline') {
            ivaRootElement.style.display = '';
        } else {
            ivaRootElement.style.display = isOpen ? 'block' : 'none';
        }
    }, [isOpen, ivaType]);
}